import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClock3OClock: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clock-3-o-clock, time, 3-00"><path d="M12 6.75V12H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconClock3OClock;
